import { useState } from 'react';
import { Box, Checkbox, Stack, Typography } from '@mui/material';
import styles from './AdsListSelect.module.scss';
import { DeleteIcon, PDFIcon } from '../../svg';
import { DeleteDialog, SavePdfDialog } from '../../FavoritesDialogs';

interface AdsListControlsProps {
  selectAll: boolean;
  handleSelectAllChange: () => void;
  selectedAds: string[];
  countSelected: number | null;
  deleteListings: () => void;
}

export const AdsListSelect = ({
  selectAll,
  handleSelectAllChange,
  selectedAds,
  countSelected,
  deleteListings,
}: AdsListControlsProps) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);

  const onHandleClick = () => {
    deleteListings();
    setOpenDeleteDialog(false);
  };

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent='space-between'
      className={styles.bulkRow}
    >
      <Stack direction={'row'} alignItems={'center'} className={styles.bulkControls}>
        <Checkbox
          icon={<span />}
          checkedIcon={<span className={styles.checked} />}
          onChange={handleSelectAllChange}
          checked={selectAll}
        />
        {selectedAds.length > 1 && (
          <Stack direction={'row'} alignItems={'center'} spacing={5} className={styles.listActions}>
            <Box className={styles.buttonWrap} onClick={() => setOpenPdfDialog(true)}>
              <PDFIcon />
              Save as PDF
            </Box>
            <Box className={styles.buttonWrap} onClick={() => setOpenDeleteDialog(true)}>
              <DeleteIcon />
              Delete
            </Box>
          </Stack>
        )}
      </Stack>
      {countSelected && (
        <Typography sx={{ color: '#1650FF', fontSize: '18px' }}>
          {'Selected '}
          <strong>{countSelected}</strong>
          {' ads'}
        </Typography>
      )}
      <DeleteDialog
        title='Are you sure you want to delete these listings from collection?'
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onClick={onHandleClick}
      />
      <SavePdfDialog
        open={openPdfDialog}
        setOpenDialog={setOpenPdfDialog}
        selectedAds={selectedAds}
      />
    </Stack>
  );
};
